import React from "react";

import { CodeIcon, DataIcon, DocIcon, PromptsIcon, BookmarkIcon, TestCaseIcon } from "../assets/SvgIcons";


const EmptyStateTilesConfig = {
    tiles: [
        {
            id: "analyze_document",
            title: "Analyze Document",
            tileType: "DocumentUpload",
            description: "Upload a document for AI-powered analysis and summarization.",
            extendedDescription: "Upload a document to leverage AI-powered analysis and summarization. This feature allows you to quickly understand the key points and insights from your document, saving you time and effort. The AI will read through the document, identify important sections, and provide a concise summary that highlights the most critical information. This is particularly useful for lengthy reports, research papers, and other detailed documents.",
            action: "documentSelect",
            icon: <DocIcon width={100} height={100} />,
            smallIcon: <DocIcon width={40} height={40} />,
            onClick: () => console.log("Analyze Document selected"),
        },
        {
            id: "analyze_dataset",
            title: "Analyze Dataset",
            tileType: "DataSelection",
            description: "Process and gain insights from structured datasets.",
            extendedDescription: "Process and gain insights from structured datasets. This feature helps you to analyze large datasets, identify patterns, and extract meaningful information to make data-driven decisions. Whether you are working with financial data, customer information, or any other type of structured data, this tool will help you uncover trends and correlations that might not be immediately obvious. It can also generate visualizations to help you better understand the data.",
            action: "documentSelect",
            icon: <DataIcon width={100} height={100} />,
            smallIcon: <DataIcon width={40} height={40} />,
            onClick: () => console.log("Analyze Dataset selected"),
        },
        {
            id: "code_assistant",
            title: "Code Assistant",
            tileType: "CodeEditor",
            description: "Improve and optimize your existing code with AI suggestions.",
            extendedDescription: "Improve and optimize your existing code with AI suggestions. This feature provides recommendations for code refactoring, helping you to enhance code quality, maintainability, and performance. The AI will analyze your codebase, identify areas that can be improved, and suggest changes that follow best practices. This can include simplifying complex logic, improving variable names, and ensuring consistent formatting. By following these suggestions, you can make your code more readable and easier to maintain.",
            action: "documentSelect",
            icon: <CodeIcon width={100} height={100} />,
            smallIcon: <CodeIcon width={40} height={40} />,
            onClick: () => console.log("Refactor Code selected"),
        },
        {
            id: "manage_saved_prompts",
            title: "Saved Prompts",
            tileType: "PromptManager",
            description: "Access and manage your saved prompts.",
            extendedDescription: "Access and manage your saved prompts. This feature allows you to view, edit, and organize all the prompts you have saved. You can categorize your prompts, add notes, and quickly retrieve them when needed. This is particularly useful for keeping track of frequently used prompts, ensuring you have quick access to them without having to recreate them each time. The management interface is user-friendly and designed to help you stay organized and efficient.",
            action: "documentSelect",
            icon: <BookmarkIcon width={100} height={100} />,
            smallIcon: <BookmarkIcon width={40} height={40} />,
            onClick: () => console.log("Manage Saved Prompts selected"),
        },
        {
            id: "generate_test_cases",
            title: "Automated Tasks",
            tileType: "TestCaseManager",
            description: "Create automated tasks for a veriety of scenarios.",
            extendedDescription: "Automatically create test cases for your codebase. This feature uses AI to generate comprehensive test cases, ensuring your code is thoroughly tested and reducing the likelihood of bugs. The AI will analyze your code, understand its functionality, and create test cases that cover a wide range of scenarios. This helps to ensure that your code behaves as expected in different situations and edge cases, improving the overall reliability and robustness of your software.",
            action: "documentSelect",
            icon: <TestCaseIcon width={100} height={100} />,
            smallIcon: <TestCaseIcon width={40} height={40} />,
            onClick: () => console.log("Automated Tasks selected"),
        },
    ],
};

export default EmptyStateTilesConfig;